import { PropsWithChildren } from 'react';

import { twMerge } from '@/domains/core/tamagoshiTailwind/util/twMerge';

export const Block = ({
  children,
  className,
}: PropsWithChildren & { className?: string }) => {
  // 1376px is the max width of the content that corresponds to 1440px - 2x 32px paddingº
  return (
    <div
      className={twMerge(
        `w-full max-w-[1376px] bg-foundation-inverted p-m empty:hidden
        desktop:rounded-container desktop:px-[82px] desktop:py-xl`,
        className,
      )}
    >
      {children}
    </div>
  );
};

Block.displayName = 'Block';
